<div class="page-wrapper">
	<div class="card card--slack">
		<div class="card-header text-center">
			<h1>Slack integration</h1>
		</div>
		<div class="card-body">
			<div class="c-slack" *ngIf="!showError">
				<span class="c-slack__dot c-slack__dot--a"></span>
				<span class="c-slack__dot c-slack__dot--b"></span>
				<span class="c-slack__dot c-slack__dot--c"></span>
				<span class="c-slack__dot c-slack__dot--d"></span>
			</div>
			<div *ngIf="showError">
				<div class="alert alert-danger mt-3 mr-3 ml-3">
					{{ errorMessage }}
				</div>
				<button (click)="backToDashboard()" class="btn btn-secondary" type="button">Back to dashboard</button>
			</div>
		</div>
	</div>
</div>
